import { Box } from "@material-ui/core";
import { postAboutMe } from "adapters";
import { DialogWrapper } from "components/shared/dialog";
import { RichTextEditor } from "components/shared/rich-text-editor";
import { useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetUrlBuilderData, SetUrlBuilderData } from "store/url-builder";

import { exportToHtml } from "components/shared/rich-text-editor";
import { ContentState, convertToRaw } from "draft-js";

export interface EditAboutMeDialogProps {
  isOpen: boolean;
  onClose(): void;
  builderType: string;
}

// Function to preserve text alignment by processing HTML after conversion
const processHtmlWithAlignment = (
  html: string,
  contentState: ContentState
): string => {
  // Convert contentState to raw to access block data
  const rawContent = convertToRaw(contentState);

  let blockIndex = 0;
  // Normalize and apply alignment for p, headings and divs in order
  const processedHtml = html.replace(
    /<(p|h[1-6]|div)([^>]*)>/gi,
    (fullMatch, tag, attrs) => {
      const block = rawContent.blocks[blockIndex++];
      const currentAlign = block?.data?.textAlign as string | undefined;
      let baseAttrs = attrs || "";
      // Remove any style attribute completely
      baseAttrs = baseAttrs.replace(/\s?style="[^"]*"/gi, "");
      // Always append the correct text-align style for these tags, if alignment is set
      if (currentAlign && ["left", "center", "right", "justify"].includes(currentAlign)) {
        baseAttrs += ` style="text-align: ${currentAlign}"`;
      }
      console.log(`[DEBUG] tag: ${tag}, currentAlign: ${currentAlign}, baseAttrs: ${baseAttrs}`);
      return `<${tag}${baseAttrs}>`;
    }
  );

  return processedHtml;
};

export const EditAboutMeDialog = ({
  isOpen,
  onClose,
  builderType,
}: EditAboutMeDialogProps) => {
  const [loading, setLoading] = useState(false);
  const builderData = useSelector(GetUrlBuilderData);
  const [editorState, setEditorState] = useState<any>();
  const dispatch = useDispatch();
  const { cardId }: { cardId: string } = useParams();

  const submit = () => {
    setLoading(true);

    if (!editorState?.getCurrentContent()) {
      onClose();
      setLoading(false);
      return;
    }

    // Use exportToHtml for semantic block HTML (now includes alignment)
    let markup = exportToHtml(editorState);
    console.log('[DEBUG] exportToHtml result:', markup);
    // Improved: check for real content not just markup === '<p></p>'
    const isEmptyHtml = !markup || markup.trim().replace(/<[^>]+>/g, '').trim() === '';
    const aboutMeHtmlInput = isEmptyHtml ? '' : markup;
    console.log('[DEBUG] aboutMeHtmlInput to be saved:', aboutMeHtmlInput);

    postAboutMe(cardId, builderType, aboutMeHtmlInput)
      .then(({ data }) => {
        if (!data.success) return;
        dispatch(SetUrlBuilderData(data.data));
        onClose();
      })
      .finally(() => setLoading(false));
  };

  return (
    <DialogWrapper
      open={isOpen}
      onClose={onClose}
      loading={loading}
      onSubmit={submit}
      title="About Me"
      enableFullScreen
    >
      <Box minHeight="40vh">
        <RichTextEditor
          onChange={setEditorState}
          initialState={builderData.aboutMe.text}
        />
      </Box>
    </DialogWrapper>
  );
};
